//YAML Helpers
import yaml from 'js-yaml';
import { isProxy, toRaw } from 'vue';
import { defineStore } from 'pinia';
import prettier from 'prettier';

export const routeStore = defineStore('routes', () => {
  const route = useRoute();
  const visitedURLs = ref([route.path])
  watch(route, (route) => visitedURLs.value.unshift(route.path));
  return {route, visitedURLs};
});

export const yamlOrJSON= (string) => {
  try {
      return JSON.parse(string);
  } catch (e) {
      try {
          return yaml.load(string);
      } catch (e) {
        try {
          return prettier.format(string, { parser: "yaml" });
        } catch (e) {
          console.error('cant read:\n',string);
          return false; // Neither valid JSON nor YAML
        }
      }
  }
};

export const cleanString = (string) => {
  console.log(string);
  return string;
};

export const cleanArrayItems = (array) => {
  return array.map(function(item){return item.trim()});
};

export const yamlToObject = (string) => yaml.load(string);
export const yamlFirst = (string) => yaml.load(string) && yaml.load(string)[0].length > 1 ? yaml.load(string)[0].trim() : string;

//JSON Helpers
export const cleanUpJSON = (input) => input != undefined ? JSON.parse(JSON.stringify(input)) : '';

export const objectToArray = (proxyObject) => {return toRaw(proxyObject)};


//URL to PATH
export const pathName = function(input) {
  let url = input ? new URL(input) : {pathname: false};
  return url.pathname;
}

//URL to PATH
export const removeBodyClass = function(className) {
  document.body.classList.remove(className);
}
export const addBodyClass = function(className) {
  document.body.classList.add(className);
}

//Get alternative language
export const alternativeLanguage = function(i) {
  const linkElementForAlternate = document.head.querySelector('link[rel=alternate]');
  return linkElementForAlternate ? linkElementForAlternate.attributes.hreflang.value : false;
}

//Get image from files object by id
export const imageById = function(images, filename) {
  if(!images || !filename) return false;
  filename = filename.includes('/') ? filename.split('/').pop() : filename;
  const imageObject = images.filter( image => (image.filename == filename))[0];
  if(images){
    //console.log(images);
    return objectToArray(imageObject);
  } else {
    console.error('No images');
  }
}

//Local images
export const srcImage = ((url) => {
  return new URL(`/src/${url}`, import.meta.url).href;
});

//Local images
export const publicImage = ((url) => {
  return new URL(`/public/${url}`, import.meta.url).href;
});

//Get file object from path
export const fileObjectFromPath = (fileUid, pages) => {
  const filename = fileUid.substr(fileUid.lastIndexOf("/")+1);
  const path = fileUid.substring(0, fileUid.lastIndexOf("/"));
  const page = pageFromPath(path, pages);
  const image = imageById(page.images, filename)
  return (image);
}

//Get page object from path
export const pageFromPath = (path, pages) => {
  if (path && toRaw(pages).length > 0) {
    var slugs = path.trim().split('/');
    var page = false;
    var children = pages;
    while (slugs.length) {
      var id = slugs.shift();
      page = children.find(o => o.uid === id);
      if (page) children = typeof page.children === 'object' ? page.children : [];
    }
    if (page) {
      return page;
    } else {
      console.error('No page!', path, pages);
    }
  } else {
    console.info('No pages (pageFromPath):', path,'from' , toRaw(pages));
    return false;
  }
}

//Mix lines with page objects
export const featuresAndLines = function(features, featureSizes) {
  const query = (Array.isArray(features) && features.length && features[0] && features[0].uid!=false );
  const sizes = structuredClone(featureSizes);
  if(query){
    var featureLength = parseInt(features.length);
    var returnArray = [];
    let tween = 0;
    let lineObject = {type: 'line', page: false, uid: false};
    if(featureLength < 100){
      for (let index = 0; index < featureLength; index++) {
        const currentSize = Object.keys(sizes)[0];
        const takeFromLine = 1 / sizes[currentSize].featuresPerLine;
        sizes[currentSize].lines = sizes[currentSize].lines - takeFromLine;;
        const lineOrNot = (sizes[currentSize].lines.toFixed(1) % 1) == 0;
        if(sizes[currentSize].lines==0) {
          delete sizes[currentSize];
        };
        features[index].featureSize = currentSize;
        returnArray.push(features[index]);
        if(lineOrNot) {
          returnArray.push(lineObject);
        }
      }
    }
  }
  return returnArray;
}

//Get page objects with list of paths
export const urlToRelative = function(input) {
  const url = new URL(input);
  return url.toString().substring(url.origin.length)
}

//Get page objects with list of paths
export const pagesFromPaths = function(list, pages) {
  if(list !='undefined' && pages.length) {
    let self = this;
    let paths = (typeof list == 'array') ? list : Object.values(list);
    let returnArray = [];
    paths.map(function(path){
      let page = pageFromPath(path, pages);
      if(page) returnArray.push(page);
    });
    //console.log( Array.isArray(returnArray));
    return returnArray;
  }
}

export const FPSCounter = function(numSamples = 60) {
  let lastFrameTime = performance.now();
  let frameTimes = [];

  this.currentFPS = function() {
      if (frameTimes.length === 0) return 0;
      const sum = frameTimes.reduce((a, b) => a + b);
      return (sum / frameTimes.length).toFixed(2); // Average FPS over the sample window
  }

  // Function to call on each frame
  this.update = function() {
      const now = performance.now();
      const deltaTime = now - lastFrameTime;
      const fps = 1000 / deltaTime;  // Calculate the current FPS based on the time since last frame

      // Update the list of frame times
      frameTimes.push(fps);
      if (frameTimes.length > numSamples) {
          frameTimes.shift(); // Remove the oldest frame time to maintain a window of 'numSamples'
      }

      lastFrameTime = now; // Update last frame time for the next frame
  };
}

//Seconds to minutes
export const secondsToDigitalDisplay = (seconds) => {
  var minutes=0;
  var output = '00:00';
  if(seconds > 0) output = ((minutes = ((seconds-(seconds%=60))/60)) < 9 ? '0'+ minutes : minutes)+(9<seconds?':':':0')+Math.round(seconds);
  return output
}

export const crossOriginSRCSET = (srcset) => {
  // Split the srcset into an array of URL and descriptor pairs
  const srcsetParts = srcset.split(', ');

  // Map each part to a relative URL
  const relativeSrcset = srcsetParts.map(part => {
    // Split part into URL and descriptor
    const [url, descriptor] = part.split(' ');
    // Create a URL object to easily extract the pathname
    const urlObj = new URL(url);
    // Rebuild the part with the relative path and descriptor
    return `${urlObj.pathname} ${descriptor}`;
  });

  // Join the parts back into a srcset string
  return relativeSrcset.join(', ');
}
